import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSpecialistAuth } from '../../context/SpecialistAuthContext';

const SpecialistProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useSpecialistAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: 'Poppins, sans-serif',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default SpecialistProtectedRoute;
